<template>

  <div>

    <assets-add-new
      :is-add-new-asset-sidebar-active.sync="isAddNewAssetSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <!-- <assets-filters :role-filter.sync="roleFilter" :plan-filter.sync="planFilter" :status-filter.sync="statusFilter"
      :role-options="roleOptions" :plan-options="planOptions" :status-options="isActiveOptions" /> -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>items</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">

              </b-form-checkbox>
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Pesquisar..."
              />
              <b-button
                variant="outline-primary mr-1"
                class="mr-1"
                @click="isAddNewAssetSidebarActive = true"
              >
                <span class="text-nowrap">+ Ativo</span>
              </b-button>

              <b-button
                variant="outline-primary mr-1"
                @click="showMap = !showMap"
              >
                <span class="text-nowrap">Ver Mapa</span>
              </b-button>

            </div>
          </b-col>
        </b-row>
      </div>

      <assets-map
        v-if="showMap"
        style="height:350px;"
      />

      <b-table
        ref="refAssetListTable"
        class="position-relative"
        :items="fetchAssets"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Index -->
        <template #cell(id)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.id }}</span>
          </div>
        </template>

        <!-- Column: Model -->
        <template #cell(model)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.model }}</span>
          </div>
        </template>

        <!-- Column: Firmware -->
        <template #cell(firmware)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.firmware }}</span>
          </div>
        </template>
        <!-- <template #cell(firmware)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.firmware)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.firmware)}`"
            />
            <span class="align-text-top text-capitalize">{{ data.item.firmware }}</span>
          </div>
        </template> -->

        <!-- Column: Model -->
        <template #cell(deviceKey)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.deviceKey }}</span>
          </div>
        </template>

        <!-- Column: isActive -->
        <template #cell(isActive)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.isActive)}`"
            class=""
          >
            {{ data.item.isActive }}
          </b-badge>
        </template>

        <!-- Column: LastData -->
        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.createdAt }}</span>
          </div>
        </template>

        <!-- Column: Type -->
        <template #cell(status)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.status)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.status)}`"
            />
            <span class="align-text-top text-capitalize">{{ data.item.status }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'apps-users-view', params: { id: data.item.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-dropdown-item>

            <b-dropdown-item :to="{ name: 'apps-users-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{ dataMeta.of }}
              items</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalAssets"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import AssetsFilters from './AssetsFilters.vue'
import assetsList from './assetsList'
import assetsStoreModule from './assetsStoreModule'
import AssetsAddNew from './AssetsAddNew.vue'
import AssetsMap from './AssetsMap.vue'

export default {
  components: {
    AssetsFilters,
    AssetsAddNew,
    AssetsMap,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  data() {
    return {
      showMap: false,
    }
  },
  setup() {
    const ASSET_APP_STORE_MODULE_NAME = 'app-asset'
    // console.log(fetchUsers)

    // Register module
    if (!store.hasModule(ASSET_APP_STORE_MODULE_NAME)) store.registerModule(ASSET_APP_STORE_MODULE_NAME, assetsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ASSET_APP_STORE_MODULE_NAME)) store.unregisterModule(ASSET_APP_STORE_MODULE_NAME)
    })

    const isAddNewAssetSidebarActive = ref(false)

    const roleOptions = [
      { label: 'Reefer', value: 'admin' },
      { label: 'Veículo', value: 'author' },
      { label: 'Refrigerador', value: 'editor' },
    ]

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ]

    const isActiveOptions = [
      { label: 'Pendente', value: 'null' },
      { label: 'Ativo', value: 'true' },
      { label: 'Inativo', value: 'false' },
    ]

    const {
      fetchAssets,
      tableColumns,
      perPage,
      currentPage,
      totalAssets,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refAssetListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = assetsList()

    return {
      // Sidebar
      isAddNewAssetSidebarActive,

      fetchAssets,
      tableColumns,
      perPage,
      currentPage,
      totalAssets,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refAssetListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      isActiveOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
